import { Component } from '@angular/core';

@Component({
  selector: 'pdf-find-regexp',
  templateUrl: './pdf-find-regexp.component.html',
})
export class PdfFindRegExpComponent {}
